import { SimpleProduct } from "./SimpleProduct";

export interface Scanner {
  company_id: string;
  products: SimpleProduct[];
  code: string;
  name: string;
  id: string;
}
